import News2 from "../assets/news/news2.webp";
import News3 from "../assets/news/news3.webp";
import News4 from "../assets/news/news4.webp";
import Fuar3 from "../assets/fuar3.webp";
import Fuar3mobil from "../assets/fuar3mobil.webp";
import Finalist1 from "../assets/home/finalist1.webp";
import Finalist2 from "../assets/home/finalist2.webp";
import Finalist3 from "../assets/home/finalist3.webp";
import MemberLogo1 from "../assets/home/test1.png";
import MemberLogo2 from "../assets/home/test2.png";
import Winner1 from "../assets/home/winner1.png";

const FairsData = {
  attended: [
    { id: 1, title: "", location: "", date: "", image: News4, description: "" },
    { id: 2, title: "", location: "", date: "", image: News3, description: "" },
    { id: 3, title: "", location: "", date: "", image: News2, description: "" },
  ],
  upcoming: [
    {
      id: 4,
      title: "Beauty West Africa 2026",
      location: "",
      date: "",
      image: Fuar3,
      mobileImage: Fuar3mobil,
      description: "",
      link: "/news",
    },
  ],
  awards: [
    {
      groupKey: "recognition",
      labelKey: "Award Winner",
      items: [{ id: 101, title: "Travel Retail Awards 2026", image: Winner1 }],
    },
    {
      groupKey: "finalist",
      labelKey: "Finalist",
      items: [
        { id: 201, title: "Attracta Beauty Awards 2026", image: Finalist1 },
        { id: 202, title: "Travel Retail Awards 2026", image: Finalist2 },
      ],
    },
    {
      groupKey: "recognition",
      labelKey: "OfficialRecognition",
      items: [
        { id: 301, title: "Cosmoprof NA Las Vegas 2026", image: Finalist3 },
      ],
    },
    {
      groupKey: "member",
      labelKey: "Memberof",
      items: [
        { id: 401, title: "The Fragrance Foundation UK", image: MemberLogo1 },
        { id: 402, title: "MHB Group", image: MemberLogo2 },
      ],
    },
  ],
};

export default FairsData;
